// Convert Arabic/Persian numbers to English numbers
export const convertToEnglishNumbers = (str) => {
  const arabicNumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  
  if (!str) return str;
  
  let result = str.toString();
  
  // Convert all Persian/Arabic numbers to English
  for (let i = 0; i < 10; i++) {
    const arabicRegex = new RegExp(arabicNumbers[i], 'g');
    const persianRegex = new RegExp(persianNumbers[i], 'g');
    result = result
      .replace(arabicRegex, i.toString())
      .replace(persianRegex, i.toString());
  }
  
  return result;
}

// Check if a character is a Persian or Arabic number
export const isPersianOrArabicNumber = (char) => {
  const arabicNumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  return arabicNumbers.includes(char) || persianNumbers.includes(char);
}